/* eslint-disable */
import { Field } from "react-final-form";
import { Link } from "react-router-dom";
import Select from "react-select";

export default function BankDetailsForm() {
  return (
    <div className="col-xl-6 col-lg-12">
      <div className="form-group-bank">
        {/* <div className="row align-items-center">
          <div className="col-md-8">
            <div className="input-block mb-3">
              <label>Select Bank</label>
              <Field name="bank">
                {({ input }) => (
                  <Select
                    {...input}
                    value={input.value}
                    onChange={input.onChange}
                    // options={formattedOptions(bank)}
                    placeholder="Select Bank"
                  />
                )}
              </Field>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-groups">
              <Link
                className="btn btn-primary"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#bank_details"
              >
                Add Bank
              </Link>
            </div>
          </div>
        </div> */}
        <div className="input-block mb-3 notes-form-group-info">
          <label>Notes</label>
          <Field
            name="notes"
            component="textarea"
            className="form-control"
            placeholder="Enter Notes"
          />
        </div>
        <div className="input-block mb-3 notes-form-group-info mb-0">
          <label>Terms and Conditions</label>
          <Field
            name="terms"
            component="textarea"
            className="form-control"
            placeholder="Enter Terms and Conditions"
          />
        </div>
      </div>
    </div>
  );
}
